// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { eosTestnet as _eosTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the eosTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 15557
 * Chain Name: EOS EVM Testnet
 * Default Block Explorer: https://explorer.testnet.evm.eosnetwork.com
 * Default RPC URL: https://api.testnet.evm.eosnetwork.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { eosTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: eosTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const eosTestnet = createCommon({
	..._eosTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
